import questionsBanksAPI from '@/api/questionsBanksAPI'

const state = {
  all: [],
  current: {},
}

const getters = {}

const actions = {
  load({commit}){
    return new Promise((resolve, reject) => {
      questionsBanksAPI.getAll()
        .then(({data}) => {
          resolve(data.questions_banks)
          commit('SET_QUESTION_BANKS', data.questions_banks)
        })
        .catch(error => reject(error))
    })
  },
  loadByCourse({commit}){
    return new Promise((resolve, reject) => {
      questionsBanksAPI.getByCourse()
        .then(({data}) => {
          resolve(data.questions_banks)
          commit('SET_QUESTION_BANKS', data.questions_banks)
        })
        .catch(error => reject(error))
    })
  },
  getQuestionsBank({commit, state}, id){
    return new Promise(async (resolve, reject) => {
      const questionBank = state.all.find(bank => bank.id === id)
      if(!questionBank.questions){
        await questionsBanksAPI.getById(id).then(({data}) => {
          questionBank.questions = data.questions
        }).catch(error => reject(error))
      }
      commit('SET_CURRENT_QUESTION_BANK', questionBank)
      resolve(questionBank)
    })
  },
  create({commit}, questionBank){
    return new Promise((resolve, reject) => {
      questionsBanksAPI.create(questionBank).then(response => {
        questionBank.id = response.data.id
        commit("ADD", questionBank)
        resolve(response)
      }).catch(error => reject(error))
    })
  },
  remove({commit}, id){
    return new Promise((resolve, reject) => {
      questionsBanksAPI.delete(id).then(response => {
        commit("REMOVE", id)
        resolve(response)
      }).catch(error => reject(error))
    })
  },
  update({commit}, questionBank){
    return new Promise((resolve, reject) => {
      questionsBanksAPI.update(questionBank.id, questionBank).then(response => {
        commit("UPDATE", questionBank)
        resolve(response)
      }).catch(error => reject(error))
    })
  },
}

const mutations = {
  SET_QUESTION_BANKS(state, questionBanks) {
    state.all = questionBanks
  },
  SET_CURRENT_QUESTION_BANK(state, questionBank){
    state.current = questionBank
  },
  ADD(state, questionBank){
    state.all.unshift(questionBank)
  },
  UPDATE(state, questionBank){
    let index = state.all.findIndex(bank => bank.id === questionBank.id)
    state.all.splice(index, 1, questionBank)
  },
  REMOVE(state, id){
    const index = state.all.findIndex(bank => bank.id === id)
    state.all.splice(index, 1)
  },
}

export default({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
});
